import React, { useContext, useState } from 'react';
import Avatar from '@mui/material/Avatar';
import { Popover, useMediaQuery, useTheme } from '@mui/material';
import { AuthContext } from '../../../../Context/authContext';
import { TABLET_BREAKPOINT } from '../../../../Constants/constant';

const Header = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const {
    state: { user },
    dispatch,
  } = useContext(AuthContext);

  const theme = useTheme();

  const isMobileScreen = useMediaQuery(
    theme.breakpoints.down(TABLET_BREAKPOINT)
  );

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  return (
    <div className="bg-white Outer-Header-Container">
      <div className="w-100">
        <div className="d-flex justify-content-between py-3 px-5 align-items-center">
          <h1 className="font-black-24-bold text-capitalize m-0 p-0">
            {props.Heading}
          </h1>
          <div
            className="d-flex gap-3 align-items-center"
            onClick={(e) => {
              handleClick(e);
            }}
          >
            <Avatar />
            <h1 className="font-black-16-bold text-capitalize m-0 p-0">
              {isMobileScreen
                ? props?.user?.applicantName[0]
                : props?.user?.applicantName}
            </h1>
          </div>
        </div>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          <h6
            className="menu-tabs font-black-14-bold my-0 py-3 px-3"
            onClick={() => {
              dispatch({
                type: 'LOGOUT',
                payload: {
                  user: {},
                  token: null,
                },
              });
            }}
          >
            Logout
          </h6>
        </Popover>
        <div className="px-5">
          {props.divider && <div className="divider"></div>}
        </div>
      </div>
    </div>
  );
};

export default Header;
